import {skipToken} from '@reduxjs/toolkit/query';
import {Option} from 'platform/components';

import {isNil, isNotNil} from 'ramda';

import {useGetTrimLevelsQuery} from '@dms/api/sales';

import {usePurchasePriceRuleCatalogue} from '../../../hooks/usePurchasePriceRuleCatalogue';
import {getSinglePurchasePriceRuleMake} from '../../../utils/getSinglePurchasePriceRuleMake';
import {resolvePurchasePriceRuleLabel} from '../../../utils/resolvePurchasePriceRuleLabel';

/**
 * Options of the scope fields. Model families and trims are offered only for exactly one selected
 * make. Without selected model families the trims of the whole make are offered.
 */
export function usePurchasePriceRuleScopeOptions(makes: string[], modelFamilies: string[]) {
  const {data: catalogue, isLoading: isCatalogueLoading} = usePurchasePriceRuleCatalogue();

  const singleMake = getSinglePurchasePriceRuleMake(makes);

  const {currentData: trims, isFetching: isTrimsFetching} = useGetTrimLevelsQuery(
    isNil(singleMake) ? skipToken : {make: singleMake, modelFamilies}
  );

  const makeOptions: Option[] = Object.values(catalogue?.makes ?? {}).map((make) => ({
    value: make.name,
    label: make.label,
  }));

  const modelFamilyKeys = isNil(singleMake) ? [] : (catalogue?.makes[singleMake]?.models ?? []);
  const modelFamilyOptions: Option[] = modelFamilyKeys.map((key) => ({
    value: key,
    label: resolvePurchasePriceRuleLabel({key, catalogue, trims: undefined}),
  }));

  return {
    makeOptions,
    modelFamilyOptions,
    trimOptions: trims ?? [],
    isMakesLoading: isCatalogueLoading,
    isTrimsLoading: isTrimsFetching,
    hasSingleMake: isNotNil(singleMake),
  };
}
